import React, { useMemo } from 'react';
import useLocalization from 'localization';
import useTheme from 'branding/theme';
import withHover from '../../hocs/withHover';
import withFocus from '../../hocs/withFocus';
import useComponentMargin from '../../hooks/useComponentMargin';
import Span from '../../typography/Span';
import handleStickyFocus from '../../utils/handleStickyFocus';
export const CircularButton = ({ onClick, children, alt, variant = 'primary', size = 'regular', disabled = false, type = 'button', isHovered, handleMouseEnter, handleMouseLeave, isFocused, handleFocus, handleBlur, margin, marginHorizontal, marginVertical, marginTop, marginBottom, marginLeft, marginRight, isLink, gatsbyLink, href, styles }) => {
    const { t } = useLocalization();
    const altText = typeof children === 'number' ? String(children) : alt && t(alt);
    const handleClick = handleStickyFocus(handleBlur, onClick);
    const { colors, inputs: { base, shape, size: inputSize, buttonStyles }, typography, sizing: { widths: { circle } } } = useTheme();
    const marginStyles = useComponentMargin({
        margin,
        marginHorizontal,
        marginVertical,
        marginTop,
        marginBottom,
        marginLeft,
        marginRight
    });
    const buttonStylesOverrides = {
        padding: 0,
        lineHeight: 0,
        width: circle[size],
        height: circle[size]
    };
    const textStyles = useMemo(() => ({
        ...typography.paragraph.large,
        ...typography.strong,
        color: variant === 'primary' ? colors.neutrals.background : colors.neutrals.textAlpha
    }), [typography, colors, variant]);
    const mergedStyles = {
        ...base,
        ...shape.pill,
        ...inputSize[size],
        ...buttonStyles.variant[variant],
        ...((isHovered || isFocused) && buttonStyles.hovered[variant]),
        ...(disabled && buttonStyles.disabled[variant]),
        ...marginStyles,
        ...buttonStylesOverrides,
        ...styles
    };
    const processedChildren = typeof children === 'string' || typeof children === 'number' ? (React.createElement(Span, { styles: textStyles }, children)) : (children);
    const Element = React.useMemo(() => (isLink ? gatsbyLink || 'a' : 'button'), [isLink, gatsbyLink]);
    const props = React.useMemo(() => isLink
        ? {
            ...(Element === 'a' ? { ...(href && { href }) } : { to: href })
        }
        : {
            type,
            disabled
        }, [isLink, Element, href, type, disabled]);
    return (React.createElement(Element, { title: altText, ...props, onClick: handleClick, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onFocus: handleFocus, onBlur: handleBlur, style: mergedStyles }, processedChildren));
};
export default withHover(withFocus(CircularButton));
//# sourceMappingURL=index.js.map